import { isRouteErrorResponse, useRouteError } from 'react-router';

import { isApiError } from '@core/api/errors';
import { ErrorState } from '@core/ui';

/**
 * Last resort for a route that threw.
 *
 * Shows the traceId when there is one, because that string is the only thing that
 * connects a user's "it broke" to a specific log line on the server.
 */
export function RootErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorState
        title={error.status === 404 ? 'Page not found' : `Error ${error.status}`}
        message={error.statusText}
        onRetry={() => window.location.reload()}
      />
    );
  }

  if (isApiError(error)) {
    return (
      <ErrorState
        message={error.message}
        traceId={error.traceId}
        onRetry={() => window.location.reload()}
      />
    );
  }

  return (
    <ErrorState
      message={error instanceof Error ? error.message : undefined}
      onRetry={() => window.location.reload()}
    />
  );
}
